module.exports = __webpack_public_path__ + "static/media/JPBA02.092adf1e.jpg";